import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  background: #f0f0f5 !important;
  padding: 40px 0px !important;
  margin: 0px !important;

  ${media.xl`
    padding: 100px 0px !important;
  `}
`;

export const StyledContentBlock = styled.div`
  max-width: 1440px;
  padding: 0px !important;
  margin: auto;
`;

export const MainContainer = styled.div`
  padding: 0px 20px !important;

  ${media.md`
    padding: 0px 60px !important;
  `}

  ${media.xl`
    padding: 0px 80px !important;
  `}
`;

export const Title = styled.h2`
  color: #1c1c1c;
  font-family: 'Elza Condensed';
  font-size: 34px;
  font-weight: 500;
  line-height: 89%;
  letter-spacing: -0.68px;
  text-transform: uppercase;
  margin: 0px 0px 10px;

  ${media.md`
    font-size: 60px;
    font-weight: 500;
    line-height: 90%;
    letter-spacing: -1.2px;
  `}

  ${media.xl`
    font-size: 70px;
    font-weight: 500;
    line-height: 85%;
    letter-spacing: -1.4px;
  `}
`;

export const FaqWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  border-bottom: 1px solid #1c1c1c;
  padding: 24px 0px;
  gap: 10px;
`;

export const FaqTitle = styled.h3`
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium';
  font-size: 16px;
  font-weight: 500;
  line-height: 135%;
  margin: 0px;

  ${media.md`
    font-size: 18px;
    font-weight: 500;
    line-height: 140%;
  `}
`;

export const FaqText = styled.p`
  color: #6B6D7B;
  font-family: 'Satoshi Variable Medium';
  font-size: 14px;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.28px;
  margin: 0px;

  ${media.md`
    font-size: 16px;
    font-weight: 500;
    line-height: 135%;
    letter-spacing: -0.32px;
  `}

  a {
    color: #4169e1;
    font-family: 'Satoshi Variable Medium';
    font-size: 16px;
    font-weight: 500;
    line-height: 135%;

    ${media.md`
      font-size: 20px;
      font-weight: 400;
      line-height: 32px;
    `}
  }
`;
